import React from 'react';
import LookerReport from './LookerReport';

const BookingProcessAnalytics = () => {
  return <LookerReport source="booking_process" title="Booking Process Analytics" />;
};

export default BookingProcessAnalytics;